import React, { useState } from "react";
import { useForm } from "react-hook-form";
import axios from "axios";
import Env from '../../runtimeEnv';

const CreateMeetingForm = () => {
  const { register, handleSubmit, setValue, watch, reset } = useForm();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);

  // List of therapists (can be fetched from an API)
  const therapists = [
    { name: "Test User - James", email: "jshu@plutonic.co" },
    { name: "Jeanette Gurr", email: "jgurr@plutonic.co" },
    { name: "Abigail Rozeboom", email: "arozeboom@plutonic.co" },
    { name: "Ashi Patel", email: "apatel@plutonic.co" },
    { name: "Stephanie Branom", email: "sbranom@plutonic.co" },
    { name: "Cooper Morgan", email: "cmorgan@plutonic.co" },
    { name: "Jessica Sigur", email: "jsigur@plutonic.co" },
    { name: "Briauna Brownfield, LMSW", email: "bbrownfield@plutonic.co" },
  ];

  // Auto-fill therapist email when a therapist is selected
  const handleTherapistChange = (event) => {
    const therapistEmail = therapists.find((t) => t.name === event.target.value)?.email || "";
    setValue("therapistEmail", therapistEmail);
  };

  // Handle form submission
  const onSubmit = async (formData) => {
    setLoading(true);
    setMessage(null);
    setError(null);

    try {
      // Ensure meetingName is provided (default if missing)
      if (!formData.meetingName) {
        formData.meetingName = "Therapy Session";
      }

      // Convert checkboxes to boolean values
      formData.park = Boolean(formData.park);
      formData.beach = Boolean(formData.beach);

      // Remove therapist if none is selected
      if (!formData.therapistEmail) {
        delete formData.therapistEmail;
      }

      // Ensure clientUserIDs contains both client and therapist (if available)
      formData.clientUserIDs = [formData.email];
      if (formData.therapistEmail) {
        formData.clientUserIDs.push(formData.therapistEmail);
      }

      // Remove unnecessary `therapist` field before sending to backend
      delete formData.therapist;

      // console.log("🔹 Sending Payload:", formData);

      // API call
      const response = await axios.post(`${Env.REACT_APP_PYTHON_API_URL}/api/admin/new-meeting`, formData);

      console.log("✅ Meeting Created Successfully:", response.data);
      setMessage({ type: "success", text: "Meeting created successfully!" });

      reset(); // Reset form after successful creation
    } catch (error) {
      console.error("❌ Error Creating Meeting:", error.response?.data || error.message);
      setMessage({
        type: "error",
        text: error.response?.data?.message || "Failed to update Meeting.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
    {message && (
        <div
          className={`p-2 text-center ${
            message.type === "success" ? "text-green-600" : "text-red-600"
          }`}
        >
          {message.text}
        </div>
      )}
    <form className="space-y-4" onSubmit={handleSubmit(onSubmit)}>
      {/* User Email */}
      <input {...register("email")} placeholder="Client Email" required className="input-field" />

      {/* Meeting Name */}
      <input {...register("meetingName")} placeholder="Meeting Name" required className="input-field" />

      {/* Session Time */}
      <input type="datetime-local" {...register("sessionTime")} required className="input-field" />

      {/* Therapist Selection */}
      <select {...register("therapist")} className="input-field" onChange={handleTherapistChange}>
        <option value="">Select a Therapist</option>
        {therapists.map((therapist, index) => (
          <option key={index} value={therapist.name}>
            {therapist.name}
          </option>
        ))}
      </select>

      {/* Auto-filled Therapist Email */}
      <input
        {...register("therapistEmail")}
        placeholder="Therapist Email"
        readOnly
        className="input-field bg-gray-200 cursor-not-allowed"
      />

     

      {/* Submit Button */}
      <button type="submit" className="button-primary" disabled={loading}>
        {loading ? "Creating Meeting..." : "Create Meeting"}
      </button>

      
    </form>
    </>
  );
};

export default CreateMeetingForm;